function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.49982 9C4.49978 9.09292 4.52562 9.18401 4.57446 9.26305C4.6233 9.34209 4.6932 9.40597 4.77632 9.4475L5.77632 9.9475C5.85257 9.9856 5.93729 10.0036 6.02244 9.99972C6.10759 9.99586 6.19034 9.9703 6.26284 9.92547C6.33533 9.88063 6.39515 9.818 6.43663 9.74354C6.47811 9.66907 6.49986 9.58524 6.49982 9.5V6C6.49993 5.75219 6.59205 5.51325 6.75832 5.3295L10.3698 1.335C10.4345 1.26328 10.4771 1.17434 10.4924 1.07894C10.5076 0.983542 10.4949 0.885766 10.4558 0.797437C10.4166 0.709109 10.3527 0.634011 10.2718 0.581226C10.1909 0.52844 10.0964 0.500228 9.99982 0.5H0.99982C0.903123 0.500035 0.808511 0.528108 0.727445 0.580818C0.646378 0.633529 0.582334 0.708615 0.543072 0.796981C0.50381 0.885348 0.491013 0.983204 0.506232 1.0787C0.521451 1.17419 0.564033 1.26322 0.62882 1.335L4.24132 5.3295C4.40759 5.51325 4.49971 5.75219 4.49982 6V9Z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "#006CA3"
});

function SvgFilterOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOutline);
export default __webpack_public_path__ + "static/media/filter-outline.d97771c4.svg";
export { ForwardRef as ReactComponent };